/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { APIReasonEnum } from './APIReasonEnum';
import {
    APIReasonEnumFromJSON,
    APIReasonEnumFromJSONTyped,
    APIReasonEnumToJSON,
} from './APIReasonEnum';

/**
 * A collection of serializer extensions, which allow for:
 * 
 * * Blacklisting fields through an "exclude" context variable
 * * Whitelisting fields through an "only" context variable
 * * Expanding related fields through an "expand" context variable
 * * Other helper methods
 * 
 * Blacklisting and whitelisting takes precedence over expanding, and can
 * be used in combination with one another.
 * @export
 * @interface APIInventoryMovementRequest
 */
export interface APIInventoryMovementRequest {
    /**
     * 
     * @type {string}
     * @memberof APIInventoryMovementRequest
     */
    source: string;
    /**
     * 
     * @type {string}
     * @memberof APIInventoryMovementRequest
     */
    target: string;
    /**
     * 
     * @type {number}
     * @memberof APIInventoryMovementRequest
     */
    amount: number;
    /**
     * 
     * @type {APIReasonEnum}
     * @memberof APIInventoryMovementRequest
     */
    reason?: APIReasonEnum | null;
}



/**
 * Check if a given object implements the APIInventoryMovementRequest interface.
 */
export function instanceOfAPIInventoryMovementRequest(value: object): value is APIInventoryMovementRequest {
    if (!('source' in value) || value['source'] === undefined) return false;
    if (!('target' in value) || value['target'] === undefined) return false;
    if (!('amount' in value) || value['amount'] === undefined) return false;
    return true;
}

export function APIInventoryMovementRequestFromJSON(json: any): APIInventoryMovementRequest {
    return APIInventoryMovementRequestFromJSONTyped(json, false);
}

export function APIInventoryMovementRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): APIInventoryMovementRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'source': json['source'],
        'target': json['target'],
        'amount': json['amount'],
        'reason': json['reason'] == null ? undefined : APIReasonEnumFromJSON(json['reason']),
    };
}

export function APIInventoryMovementRequestToJSON(value?: APIInventoryMovementRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'source': value['source'],
        'target': value['target'],
        'amount': value['amount'],
        'reason': APIReasonEnumToJSON(value['reason']),
    };
}

